import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ItemTitle from '@/views/review/components/review-config/item-title.vue';
import { queryConfig, setConfig as _setConfig } from '@/api/review.js';
export default {
  name: 'ReviewConfig',
  components: {
    ItemTitle: ItemTitle
  },
  props: {
    subjectCode: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      maxNewCount: 20,
      // 每日新卡
      maxReviewCount: 20,
      // 每日复习卡
      defaultMaxRound: 5,
      // 默认复习轮次
      defaultRoundInterval: '1, 1, 2, 3, 8',
      // 默认间隔天数
      maxRound: 5,
      // 自定义复习轮次
      roundInterval: '1, 1, 2, 3, 8',
      // 自定义间隔天数
      roundNumOptions: [1, 2, 3, 4, 5],
      // 复习轮次下拉框
      configSetMode: 0,
      // 0 默认模式 1 自定义模式
      roundIntervalMap: {} // 间隔天数数组

    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$queryConfig, status, data, maxNewCount, maxReviewCount, maxRound, roundInterval, configSetMode, cardRoundIntervalList, len;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return queryConfig({
                subjectId: _this.subjectCode
              });

            case 2:
              _yield$queryConfig = _context.sent;
              status = _yield$queryConfig.status;
              data = _yield$queryConfig.data;

              if (!(status !== 1)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              maxNewCount = data.maxNewCount, maxReviewCount = data.maxReviewCount, maxRound = data.maxRound, roundInterval = data.roundInterval, configSetMode = data.configSetMode, cardRoundIntervalList = data.cardRoundIntervalList;
              _this.maxNewCount = maxNewCount;
              _this.maxReviewCount = maxReviewCount;
              _this.maxRound = maxRound;
              _this.roundInterval = roundInterval.split(',').join('，');
              _this.configSetMode = configSetMode;
              len = cardRoundIntervalList.length;
              _this.defaultMaxRound = cardRoundIntervalList[len - 1].maxRound;
              cardRoundIntervalList.forEach(function (item) {
                _this.roundIntervalMap[item.maxRound] = item.roundInterval.split(',').join('，');
              });
              _this.defaultRoundInterval = _this.roundIntervalMap[_this.defaultMaxRound];

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 切换复习模式
    handleCheck: function handleCheck(type) {
      if (type === this.configSetMode) return;
      this.configSetMode = type;
    },
    // 自定义模式切换轮次
    handleChange: function handleChange(val) {
      this.roundInterval = this.roundIntervalMap[val];
    },
    // 保存复习设置
    setConfig: function setConfig() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_setConfig, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.maxNewCount);

                if (!(!_this2.maxNewCount || !_this2.maxReviewCount)) {
                  _context2.next = 4;
                  break;
                }

                _this2.$message.warning('卡片数量上限未设置，无法保存');

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return _setConfig({
                  edu: JSON.parse(localStorage.getItem('userInfo')).edu,
                  subjectId: _this2.subjectCode,
                  maxNewCount: _this2.maxNewCount,
                  maxReviewCount: _this2.maxReviewCount,
                  maxRound: _this2.maxRound,
                  configSetMode: _this2.configSetMode
                });

              case 6:
                _yield$_setConfig = _context2.sent;
                status = _yield$_setConfig.status;

                if (status === 1) {
                  _this2.$message.success('保存成功，该设置将会在次日生效');

                  _this2.$attrs.close();
                } else {
                  _this2.$message.warning('保存失败，请稍后重试');
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handle: function handle() {
      console.log(this.maxNewCount);
    },
    handleNewInput: function handleNewInput(e) {
      var value = +e;

      if (typeof value !== 'number') {
        this.maxNewCount = '';
        return;
      }

      this.maxNewCount = +e.replace(/\D/g, '').slice(0, 4); // // this.maxNewCount = this.maxNewCount.toString().replace(/[^0-9]/g, '')
      // if (this.maxNewCount) { this.maxNewCount = parseInt(this.maxNewCount) }
      // if (parseInt(this.maxNewCount) === 0) {
      //   this.maxNewCount = 0
      // }
    },
    handleReviewInput: function handleReviewInput(e) {
      var value = +e;

      if (typeof value !== 'number') {
        this.maxReviewCount = '';
        return;
      }

      this.maxReviewCount = +e.replace(/\D/g, '').slice(0, 4); // this.maxReviewCount = this.maxReviewCount.toString().replace(/[^0-9]/g, '')
      // if (this.maxReviewCount) this.maxReviewCount = parseInt(this.maxReviewCount)
      // if (parseInt(this.maxReviewCount) === 0) {
      //   this.maxReviewCount = 0
      // }
    }
  }
};